// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_8b-1";
export var productImage = "_8b-0";
export var titleColumn = "_8b-2";